import { render, staticRenderFns } from "./RdDictionarySelector.vue?vue&type=template&id=8008105a&scoped=true&"
import script from "./RdDictionarySelector.vue?vue&type=script&lang=ts&"
export * from "./RdDictionarySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8008105a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
